<template>
  <div class="toaster" ref="container">
    <transition-group class="toaster__items" name="toast" tag="div" @before-leave="onTransitionLeave">
      <div class="toaster__item" v-for="item in items" :key="item.id" v-swipe="(e) => onSwipe(e, item.id)">
        <notification :type="item.type" :can-close="true" @close="close(item.id)" class="toaster__notification">
          <div class="toaster__notification-text" v-html="item.message" />
        </notification>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapState } from "vuex"
import Notification from "@/shared/notification"
import { isOnMobile } from "@/utils/media"
import "@/directives/swipe"

export default {
  name: "Toaster",
  components: {
    Notification
  },
  computed: {
    ...mapState("toaster", ["items"])
  },
  methods: {
    close(id) {
      this.$store.dispatch("toaster/pop", id)
    },
    onTransitionLeave(el) {
      this.setElementPosition(el)
    },
    setElementPosition(el) {
      if (isOnMobile()) {
        const bottom = this.$refs.container.getBoundingClientRect().bottom - el.getBoundingClientRect().bottom
        el.style.bottom = `${bottom}px`
      } else {
        const top = el.getBoundingClientRect().top - this.$refs.container.getBoundingClientRect().top
        el.style.top = `${top}px`
      }
    },
    onSwipe(e, id) {
      // Change translation direction if user swipe left
      const swipedLeft = e.direction === 2
      if (swipedLeft) {
        const item = e.target.closest(".toaster__item")
        item.classList.add("toaster__item--swiped-right")
      }

      this.close(id)
    }
  }
}
</script>

<style lang="scss">
.toaster {
  position: fixed;
  bottom: 0;
  left: 50%;
  z-index: 10000;

  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: $x-wide-block-width;

  transform: translateX(-50%);

  &__items {
    position: relative;

    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  &__item {
    position: relative;
    z-index: 2;

    width: 100%;
    padding: 0 $spacing-16 $spacing-16;

    transition: all 0.3s ease-in-out;
  }

  &__notification {
    width: 100%;
  }

  &__notification-text {
    /* For long texts to be able to overflow properly */
    min-width: 0;
  }

  @include media(min-width, m) {
    top: 0;
    right: 0;
    bottom: auto;
    left: auto;

    transform: none;

    &__item {
      padding-top: $spacing-16;
      padding-bottom: 0;
    }
  }
}

.toast-enter,
.toast-leave-to {
  transform: translateX(3rem);
  opacity: 0;

  &.toaster__item--swiped-right {
    transform: translateX(-3rem);
  }
}

.toast-leave-active {
  position: absolute;
  z-index: 1;
}
</style>
